module.exports = __webpack_public_path__ + "img/soft-icon.4dca2336.svg";